import { useState, useEffect } from 'react';
import { formatDate } from './../../utils/convertDate';
import Layout from '../../components/Layout/Layout';
import CustomerServices from '../../services/CustomerServices';
import { RefreshIcon } from '@heroicons/react/outline';
import fire from './../../utils/Toastr';
import { HollowDotsSpinner } from 'react-epic-spinners';



export default function BVNDetails() {
    const bvn = new URLSearchParams(window.location.search).get("id");

    const [bvnDetails, setBVNDetails] = useState("");
    const [bvnImg, setBvnImg] = useState();
    const [loading, setLoading] = useState({ loading: false })

    const viewBVN = async () => {
        if (!bvn) {
            setBVNDetails(null);
            return;
        }
        const resp = await CustomerServices.viewCustomerBvn(bvn);
        const bvnNav = resp?.data?.bvnNavigation ?? null;
        setBVNDetails(bvnNav);
        if (bvnNav?.imageUrl) {
            setBvnImg(bvnNav.imageUrl);
        } else if (bvnNav?.base64Image) {
            const response = await fetch(bvnNav.base64Image);
            const imageBlob = await response.blob();
            const reader = new FileReader();
            reader.readAsDataURL(imageBlob);
            reader.onloadend = () => {
                const base64data = reader.result;
                setBvnImg(base64data);
            };
        }
    }
    const syncBVN = async () => {
        setLoading({ loading: true });
        const resp = await CustomerServices.bnvDetailsSync({bvn:bvn});
        if (resp) {
            fire("success", resp.message);
        setTimeout(() => {
            window.location.reload();
        }, 3000);
        }      
        setLoading({ loading: false });
    }
    useEffect(() => {
        viewBVN();
    }, [])
    return (
        <>
            <Layout title={""} pageTag={'customer'} current={'/customer/bvn'}>
                <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                    <div className='contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white'>
                        {/* form */}
                        <div className='p-6'>
                            <div className='flex justify-between'>
                                <h4 className='font-bold'>BVN DETAILS</h4>
                                <div className=" sm:mt-0 sm:ml-16 sm:flex justify-end relative flex-none">


                                </div>
                            </div>
                            <div className=' justify-center flex mb-4'>
                                <div className="mt-1 relative rounded-md flex justify-center">
                                    <img
                                        className="inline-block h-28 w-28 rounded-full border-8 border-rose-600"
                                        src={bvnImg} alt=""
                                    />
                                </div>                              
                            </div>
                            <div className=" sm:mt-0 sm:ml-16 sm:flex justify-end relative flex-none">
                            {loading.loading === false ? 
                                    <button
                                        type="button"
                                        onClick={syncBVN}
                                        className=" btn-primary align-center flex justify-center items-center rounded-md border border-transparent py-2 px-4  text-sm font-medium text-white shadow-sm  sm:w-auto"
                                    >
                                        <RefreshIcon className="w-3 mr-1.5" />
                                        Sync Details
                                    </button> :
                                    <HollowDotsSpinner size={20} color="#4D627E"/>
}
                                </div>
                            <div className=' grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6'>
                                <div className="sm:col-span-2">
                                    <label htmlFor="title" className="block text-sm font-medium text-gray-700">
                                        Title
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvn" id="bvn" defaultValue={bvnDetails?.title == null ? "N/A" : bvnDetails?.title} className="bg-gray-100 shadow-sm  block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnName" className="block text-sm font-medium text-gray-700">
                                        First Name
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnName" id="bvnName" defaultValue={bvnDetails?.firstName} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>

                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnName" className="block text-sm font-medium text-gray-700">
                                        Last Name
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnName" id="bvnName" defaultValue={bvnDetails?.lastName} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>

                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvn" className="block text-sm font-medium text-gray-700">
                                        Bank Verification Number(BVN)
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvn" id="bvn" defaultValue={bvnDetails?.bvn} className="bg-gray-100 shadow-sm  block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>

                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnBank" className="block text-sm font-medium text-gray-700">
                                        Bank Registered
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnBank" id="bvnBank" defaultValue={bvnDetails?.enrollmentBank} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnYear" className="block text-sm font-medium text-gray-700">
                                        Date of Registration
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnYear" id="bvnYear" value={formatDate(bvnDetails?.registrationDate)} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="dateOfBirth" className="block text-sm font-medium text-gray-700">
                                        Date of Birth
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="dateOfBirth" id="dateOfBirth" value={formatDate(bvnDetails?.dateOfBirth)} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="gender" className="block text-sm font-medium text-gray-700">
                                       Gender
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="gender" id="gender" value={bvnDetails?.gender} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                        Phone Number Registered
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.phoneNumber} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                        Enrollment Branch
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.enrollmentBranch} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                        Account Level
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.levelOfAccount} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                        Marital Status
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.maritalStatus} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                        State of Origin
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.stateOfOrigin} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                        State of Residence
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.stateOfResidence} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                        WatchListed
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.watchListed} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                        National Identification Number
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.nin} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                        Nationality
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.nationality} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                        LGA of Origin
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.lgaOfOrigin} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                        LGA of Residence
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.lgaOfResidence} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                        Name on Card
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.nameOnCard} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                       Email Address
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.email} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                                <div className="sm:col-span-6">
                                    <label htmlFor="bvnPhone" className="block text-sm font-medium text-gray-700">
                                        Residential Address
                                    </label>
                                    <div className="mt-1">
                                        <input type="text" name="bvnPhone" id="bvnPhone" defaultValue={bvnDetails?.residentialAddress} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}